import e from "react";
import { ApiClient as t, ReactQueryProvider as n } from "@maat/store-hooks";
import { AuthProvider as r, useAuth as i, useMeQuery as a } from "@maat/store-auth";
import { I18nProvider as o, useChangeLanguage as s } from "@maat/store-i18n";
import { OAuthConfigProvider as c } from "@maat/store-oauth";
import { SSEProvider as l } from "@maat/store-sse";
import { ChatSSEHandler as u } from "@maat/store-chat";
import { NotificationsSSEHandler as d } from "@maat/store-main";
import { AiChatProvider as f } from "@maat/store-ai";
import { useSyncErrorReporterUser as p } from "@maat/store-error/react";
import { jsx as m, jsxs as h } from "react/jsx-runtime";
//#region src/CoreProviders.tsx
var g = new t(), _ = () => {
	let { isAuthenticated: e, activeProfile: t } = i();
	return p(e ? { role: t } : null), null;
}, v = () => {
	let { isAuthenticated: t } = i(), { data: n } = a(!1), r = s(), o = t ? n?.user?.locale : void 0;
	return e.useEffect(() => {
		o && r(o);
	}, [o, r]), null;
}, y = ({ children: e, oauth: t, i18n: i }) => /* @__PURE__ */ m(n, {
	client: g,
	children: /* @__PURE__ */ h(r, { children: [/* @__PURE__ */ m(_, {}), /* @__PURE__ */ h(o, {
		...i,
		children: [/* @__PURE__ */ m(v, {}), /* @__PURE__ */ m(c, {
			config: t,
			children: /* @__PURE__ */ h(l, { children: [/* @__PURE__ */ m(d, {}), /* @__PURE__ */ m(u, { children: /* @__PURE__ */ m(f, { children: e }) })] })
		})]
	})] })
});
//#endregion
export { y as CoreProviders };
